import { supabase } from "../../supabaseClient"

export const saveAeProductionPhase = async (id = undefined, item) => {
    if (id) {
        return await supabase
            .from('AestheticProcSteps')
            .update({ ...item })
            .match({ id })
    } else {
        return await supabase
            .from('AestheticProcSteps')
            .insert([{ ...item }])
    }
}